import React, { FC, memo, useRef } from 'react'
import block from 'bem-cn'

import { CellType } from 'components/UIKit/Table/types'

import { Cell, CellProps } from '../Cell'

import './HeadCell.scss'

const b = block('table-head-cell')

type Props = Omit<CellProps, 'isHead'> & {
  onClick?: () => void
  sortable?: boolean
  isActive?: boolean
}

export const HeadCell: FC<Props> = memo(
  ({ className, type = CellType.TEXT, children, onClick, isActive, sortable, ...rest }) => {
    const contentRef = useRef<HTMLButtonElement>(null)

    const handleMouseLeave = () => {
      contentRef.current?.blur()
    }

    const clickable = sortable || Boolean(onClick)

    return (
      <Cell isHead type={type} className={b('wrapper').mix(className)} {...rest}>
        <button
          className={b('content').mix(type, clickable && 'clickable', isActive && 'isActive')}
          onClick={onClick}
          ref={contentRef}
          onMouseLeave={handleMouseLeave}>
          <div className={b('text')}>{children}</div>
        </button>
      </Cell>
    )
  },
)

HeadCell.displayName = 'HeadCell'
